import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-start gap-2 mt-5 mb-2 px-3 py-3 rounded-md bg-orange-50 border border-orange-200",
  "data-cy": "delete-recurring-warning"
};
import { ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'DeleteRecurringFeesDialog',
  setup(__props, {
    expose: __expose
  }) {
    const isVisible = ref(false);
    const deleteOption = ref('single');
    const loading = ref(false);
    let resolvePromise = null;

    /**
     * Opens the dialog and returns a promise that resolves with
     * the selected delete option ('single' | 'future') or false if cancelled.
     */
    const open = () => {
      // Reject any previously dangling promise before opening a new one
      if (resolvePromise) {
        resolvePromise(false);
        resolvePromise = null;
      }
      deleteOption.value = 'single';
      loading.value = false;
      isVisible.value = true;
      return new Promise(resolve => {
        resolvePromise = resolve;
      });
    };
    const resolve = value => {
      if (resolvePromise) {
        resolvePromise(value);
        resolvePromise = null;
      }
    };
    const confirmDelete = () => {
      isVisible.value = false;
      resolve(deleteOption.value);
    };
    const cancel = () => {
      isVisible.value = false;
      resolve(false);
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_radio = _resolveComponent("v-radio");
      const _component_v_radio_group = _resolveComponent("v-radio-group");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isVisible.value = $event),
        "max-width": "440",
        persistent: "",
        "data-cy": "delete-recurring-fees-dialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "rounded-lg"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "flex items-center justify-between px-6 pt-5 pb-0"
          }, {
            default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("span", {
              class: "text-lg font-semibold text-gray-900"
            }, "Delete Recurring Fees?", -1)), _createVNode(LlSecondaryButton, {
              icon: "mdi-close",
              variant: "text",
              size: "small",
              "aria-label": "Close",
              onClick: cancel,
              class: "text-gray-500 float-right"
            })]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: "px-6 pt-3 pb-0"
          }, {
            default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("p", {
              class: "text-sm text-gray-600 mb-4"
            }, " This fee is part of a recurring series. How would you like to handle the deletion? ", -1)), _createVNode(_component_v_radio_group, {
              modelValue: deleteOption.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => deleteOption.value = $event),
              class: "mt-1",
              "hide-details": "",
              color: "primary"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_radio, {
                value: "single",
                "data-cy": "delete-single-option",
                color: "primary"
              }, {
                label: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
                  class: "ml-1"
                }, [_createElementVNode("div", {
                  class: "text-sm font-semibold text-gray-900"
                }, " Delete this instance "), _createElementVNode("div", {
                  class: "text-xs text-gray-500"
                }, "On a specific date")], -1)]))]),
                _: 1
              }), _createVNode(_component_v_radio, {
                value: "future",
                class: "mt-2",
                "data-cy": "delete-future-option",
                color: "primary"
              }, {
                label: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
                  class: "ml-1"
                }, [_createElementVNode("div", {
                  class: "text-sm font-semibold text-gray-900"
                }, " Delete this and all future instances "), _createElementVNode("div", {
                  class: "text-xs text-gray-500"
                }, " Skips any future fees that are already billed. ")], -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_icon, {
              size: "18",
              color: "orange-darken-2",
              class: "mt-0.5 shrink-0"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-information", -1)]))]),
              _: 1
            }), _cache[6] || (_cache[6] = _createElementVNode("span", {
              class: "text-xs text-orange-900 leading-relaxed"
            }, " Any time entries associated with these fees will not be deleted. They will be unassigned and remain in the system. ", -1))])]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "px-6 pt-4 pb-5"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              onClick: cancel,
              "data-cy": "delete-recurring-cancel"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              variant: "flat",
              color: "error",
              onClick: confirmDelete,
              loading: loading.value,
              "data-cy": "delete-recurring-confirm"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Confirm Delete ", -1)]))]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};